module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/tiktok-badge-nocolor-7cef0e6a3e25fbd9023fc0fb8cb5bf47.svg";